import axiosInstance from "utils/axios";

/**
 * Service for handling alert-related API operations.
 */
const AlertService = {
  /**
   * Get the latest alerts (e.g., last 2).
   * @returns {Promise<Array>} - List of alert JSONs
   */
  getLatestAlerts: async () => {
    try {
      const response = await axiosInstance.get("api/v1/alerts/latest");
      return response.data || [];
    } catch (error) {
      console.error("Error fetching latest alerts:", error);
      return [];
    }
  },

  /**
   * Send/resend a TradingView-style alert to the backend.
   * @param {Object} alertData - JSON alert object to send
   * @returns {Promise<Object>} - Backend response
   */
  sendAlert: async (alertData) => {
    try {
      const response = await axiosInstance.post("api/v1/alerts/receive-tradingview-alert", alertData);
      return response.data;
    } catch (error) {
      console.error("Error sending alert:", error);
      throw error;
    }
  },

  /**
   * Get alert history (up to 1000 most recent alerts).
   * @param {number} limit - Maximum number of alerts to return (default: 1000, max: 1000)
   * @returns {Promise<Array>} - List of alert objects with id, data, and created_at
   */
  getAlertHistory: async (limit = 1000) => {
    try {
      const response = await axiosInstance.get(`api/v1/alerts/history?limit=${Math.min(limit, 1000)}`);
      return response.data || [];
    } catch (error) {
      console.error("Error fetching alert history:", error);
      return [];
    }
  },
};

export default AlertService;
